import mapKnownValues from "@/utils/mapKnownValues";
import { defaultDateTimeFormat } from "@/utils/defaultDateFormat";
import { roundNumber } from "@/utils/round";
import { optionalDisplayValue } from "@/utils/optionalDisplayValue";
import makeClassAttrsEnumerable from "@/utils/makeClassAttrsEnumerable";
import User from "@/classes/user";
import formatNumberAsCurrency from "@/utils/formatNumberAsCurrency";

export type StationTransactionAPIResponse = {
  id: string;
  transactionId: number;
  auth: string;
  authResponse: string;
  session: number;
  userId?: string;
  serialNo?: string;
  qrCode?: string;
  floor?: string;
  parkingSpace?: string;
  pricingPolicy?: string;
  price?: number;
  connect?: string; // DATE
  disconnect?: string; // DATE
  meterStart?: number;
  meterStop?: number;
  full?: string; // DATE
  stopReason: number;
  amount: number;
  kWh: number;
  chargeTimeMinutes: number;
  chargingMin: number;
  chargingMax: number;
  name: string;
  address: string;
  duration: string;
  unpluggedAt?: string; // DATE
};

export default class StationTransaction {
  id = "";
  name = "";
  address = "";
  duration = "";
  amount = 0;
  chargeTimeMinutes = 0;
  transactionId = "";
  serialNo = "";
  qrCode = "";
  floor = "";
  parkingSpace = "";
  auth = "";
  authResponse = "";
  chargingMax = 0; // Max Amps
  chargingMin = 0; // Min Amps
  connect = "";
  disconnect = "";
  full = "";
  kWh = 0;
  meterStart = 0;
  meterStop = 0;
  price = 0;
  pricingPolicy = "";
  session = 0; // DEPRECATE
  stopReason = "";
  userId = "";
  unpluggedAt = "";

  // After initialized information
  user: User | null = null;

  constructor(params: Partial<StationTransactionAPIResponse> | StationTransaction = {}) {
    mapKnownValues(this, params);
    makeClassAttrsEnumerable.bind(this)(StationTransaction, ["formatted"]);
  }

  get formatted() {
    return {
      id: this.id,
      user: this.userId,
      address: this.address,
      stationId: this.qrCode,
      floor: this.floor,
      parkingSpace: this.parkingSpace,
      kWh: roundNumber(this.kWh, 2).toString(),
      amount: formatNumberAsCurrency(this.amount),
      price: this.pricingPolicy === "TOU" ? undefined : `${formatNumberAsCurrency(this.price)} ${this.pricingPolicy}`,
      chargeTimeMinutes: `${this.chargeTimeMinutes} Minutes`,
      startTime: optionalDisplayValue(this.connect, defaultDateTimeFormat(new Date(this.connect))).toString(),
      stopTime: optionalDisplayValue(this.disconnect, defaultDateTimeFormat(new Date(this.disconnect))).toString(),
      meterStart: roundNumber(this.meterStart, 2).toString(),
      meterStop: roundNumber(this.meterStop, 2).toString(),
      full: optionalDisplayValue(this.full, defaultDateTimeFormat(new Date(this.full))).toString(),
      pricingPolicy: this.pricingPolicy,
      stopReason: this.stopReason,
      chargingMin: roundNumber(this.chargingMin).toString(),
      chargingMax: roundNumber(this.chargingMax).toString(),
      transactionId: this.transactionId ? this.transactionId.toString() : "",
      unpluggedAt: optionalDisplayValue(this.unpluggedAt, defaultDateTimeFormat(new Date(this.unpluggedAt))).toString()
    };
  }
}
